import React, { useRef } from "react"
import { useCustomerLogoUrls } from '../hooks'

interface CustomerLogoProps {
    customer?: string
}

const CustomerLogo: React.FC<CustomerLogoProps> = ({ customer }) => {
    const { png, svg, jpg } = useCustomerLogoUrls(customer?.toLowerCase());
    const formats = [png, svg, jpg];

    const formatIndex = useRef(0);
    const imgRef = useRef<HTMLImageElement>(null);

    const onImageError = (e: React.SyntheticEvent<HTMLImageElement, Event>) => {
        formatIndex.current += 1;

        if (formatIndex.current < formats.length) {
            e.currentTarget.onerror = null;
            e.currentTarget.src = formats[formatIndex.current];
        } else {
            console.error('All image formats failed:', formats);
        }
    };

    return (
        <img
            ref={imgRef}
            src={formats[0]}
            onError={onImageError}
            alt="logo"
            className="max-h-full"
            />
    );
};

export default CustomerLogo;